import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/rastreo',
    name: 'rastreo',
    component: () => import('../views/Rastreo.vue'),
  },
  {
    path: '/',
    name: 'envios',
    component: () => import('../views/Envios.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol != 3) {
        next();
      } else {
        next('/vecona');
      }
    },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdministracionSistema.vue'),
    children: [
      {
        path: '',
        component: () => import('../views/Usuarios.vue'),
        beforeEnter(to, from, next) {
          if (store.state.sesion.logedInUserInfo.rol == 1) {
            next();
          } else {
            next('/login');
          }
        },
      },


      {
        path: 'tarifas',
        component: () => import('../views/Tarifas.vue'),
        beforeEnter(to, from, next) {
          if (store.state.sesion.logedInUserInfo.rol == 1) {
            next();
          } else {
            next('/login');
          }
        }
      },
      {
        path: 'serviciosadicionales',
        component: () => import('../views/ServiciosAdicionales.vue'),
        beforeEnter(to, from, next) {
          if (store.state.sesion.logedInUserInfo.rol == 1) {
            next();
          } else {
            next('/login');
          }
        }
      },
      {
        path: 'cuentas',
        component: () => import('../views/Cuentas.vue'),
        beforeEnter(to, from, next) {
          if (store.state.sesion.logedInUserInfo.rol == 1) {
            next();
          } else {
            next('/login');
          }
        }
      },
      {
        path: 'sucursales',
        component: () => import('../views/Sucursales.vue'),
        beforeEnter(to, from, next) {
          if (store.state.sesion.logedInUserInfo.rol == 1) {
            next();
          } else {
            next('/login');
          }
        }
      },
      {
        path: 'fa',
        name: 'fa',
        component: () => import('../views/FraccionesArancelarias.vue'),
        beforeEnter(to, from, next) {
          if (store.state.sesion.logedInUserInfo.rol == 1) {
            next();
          } else {
            next('/login');
          }
        },
      },
      {
        path: 'contrato',
        name: 'contrato',
        component: () => import('../views/Contrato.vue'),
      },
    ]
  },
  {
    path: '/fa',
    component: () => import('../views/FraccionesArancelarias.vue'),
    beforeEnter(to, from, next) {
      //2 es mostrador
      if (store.state.sesion.logedInUserInfo.rol == 2) {
        next();
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/tarifas',
    component: () => import('../views/Tarifas.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol != 1) {
        next();
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/serviciosadicionales',
    name: 'serviciosadicionales',
    component: () => import('../views/ServiciosAdicionales.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol == 3) {
        next();
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserTokens == '') {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: '/remitentes',
    name: 'remitentes',
    component: () => import('../views/Remitentes.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol == 1) {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/cortador-de-guias',
    name: 'cortador-de-guias',
    component: () => import('../views/CortadorDeGuias.vue'),
  },
  {
    path: '/contrato',
    name: 'contratox',
    component: () => import('../views/Contrato.vue'),
  },
  {
    path: '/cortedecaja',
    name: 'cortedecaja',
    component: () => import('../views/CorteDeCaja.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol != 2) {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/destinatarios',
    name: 'destinatarios',
    component: () => import('../views/Destinatarios.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol == 1) {
        next();
      } else {
        next('/login');
      }
    },
  },

  {
    path: '/historialenvios',
    name: 'historialenvios',
    component: () => import('../views/HistorialEnvios.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol == 1) {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/historialenviosm',
    name: 'historialenviosm',
    component: () => import('../components/HistorialEnviosMostrador.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol != 1) {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/cobranza',
    name: 'cobranza',
    component: () => import('../views/ResumenCobranza.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol != 2) {
        next();
      } else {
        next('/login');
      }
    },

  },

  {
    path: '/resetpass',
    props: (route) => ({ token: route.query.Token, usuario: route.query.Usuario, }),
    name: 'resetpass',
    component: () => import('../components/ResetPasswordStep2.vue'),
  },
  {
    path: '/vecoin',
    name: 'vecoin',
    component: () => import('../views/Vecoin.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol != 2) {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/vecona',
    name: 'vecona',
    component: () => import('../views/Vecona.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol != 2) {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../views/test.vue'),
  },
  {
    path: '/test2',
    name: 'test2',
    component: () => import('../components/documentos-generados/CommercialInvoice.vue'),
  },
  {
    path: '/abonos',
    name: 'abonos',
    component: () => import('../views/AbonosMultiples.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol) {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/cortecajam',
    name: 'cortecajam',
    component: () => import('../views/CorteDeCajaMostrador.vue'),
    beforeEnter(to, from, next) {
      if (store.state.sesion.logedInUserInfo.rol != 1) {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
// TODO BORRAR TEST!!!!
router.beforeEach((to, from, next) => {
  if ((to.name !== 'login') && (to.name !== 'contrato') && (to.name !== 'contratox') && (to.name !== 'test') && (to.name !== 'resetpass') && (store.state.sesion.logedInUserTokens == '')) {
    next({
      name: 'login',
    });
  } else next();
});

export default router;
